import { ref } from 'vue';

// “仅显示在线”开关：模块级单例，切 tab / 组件重挂载后仍保持（默认关闭）
export const onlyOnline = ref(false);
